import React, { useState } from "react";
import "./Onboarding.css";
import WelcomeScreen from "./WelcomeScreen/WelcomeScreen";
import ActiveUsers from "./SuperApplication/SuperApplication";
import Exercise from "./Exercise/Exercise";
import Food from "./Food/Food";

export default function Onboarding() {
  const [step, setStep] = useState(1);

  const nextStep = () => {
    setStep(step + 1);
  };

  return (
    <div>
      {step === 1 && <WelcomeScreen onNext={nextStep} step={step} />}
      {step === 2 && <ActiveUsers onNext={nextStep} step={step} />}
      {step === 3 && <Exercise onNext={nextStep} step={step} />}
      {step === 4 && <Food onNext={nextStep} step={step}  />}
    </div>
  );
}
